export default __webpack_public_path__ + "static/media/lucie.361ffd48.jpg";